import { ROUTES } from 'utils/constants/routes';

export const getCoopPartnerRoutes = (routeMap) => {
  return Object.keys(routeMap).map((key) => ROUTES[routeMap[key]]);
};